<script>
import { Line as ReportDetailGraph } from "vue-chartjs";

export default {
  extends: ReportDetailGraph,
  props: {
    height: {
      type: String,
      default: null,
    },
    graphdetail_data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      datas: {
        labels: this.graphdetail_data.labels,
        datasets: [
          {
            label: "EG数",
            borderColor: "#0095f6",
            backgroundColor: "",
            borderWidth: 2,
            data: this.graphdetail_data.eg_data,
            pointRadius: 5,
            pointBackgroundColor: "#0095f6",
            yAxisID: "left",
          },
          {
            label: "コメント数",
            borderColor: "#0095f6",
            backgroundColor: "transparent",
            borderWidth: 2,
            data: this.graphdetail_data.comments_data,
            pointRadius: 0,
            pointBackgroundColor: "#0095f6",
            yAxisID: "left",
          },
          {
            label: "EGR",
            borderColor: "rgb(55, 191, 235)",
            backgroundColor: "transparent",
            borderWidth: 2,
            data: this.graphdetail_data.egr_data,
            pointRadius: 5,
            pointBackgroundColor: "#54ccdb",
            yAxisID: "right",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "nearest",
          intersect: false,
          titleMarginBottom: 10,
          xPadding: 10,
          yPadding: 10,
          bodySpacing: 10,
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          display: true,
          position: "top",
          align: "end",
          labels: {
            padding: 10,
            fontSize: 10,
            boxWidth: 20,
          },
        },
        scales: {
          xAxes: [
            {
              //x軸設定
              display: true, //表示設定
              barThickness: 5, //棒グラフ幅
              ticks: {
                padding: 5,
                fontColor: "#aaa",
              },
              gridLines: {
                // このオプションを追加
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              id: "left", // Y軸のID
              type: "linear", // linear固定
              position: "left", // どちら側に表示される軸か？
              ticks: {
                padding: 5,
                fontColor: "#aaa",
                min: this.graphdetail_data.minmax.engagement_count_min,
                max: this.graphdetail_data.minmax.engagement_count_max,
              },
            },
            {
              id: "right",
              type: "linear",
              position: "right",
              gridLines: {
                // このオプションを追加
                drawOnChartArea: false,
              },
              ticks: {
                padding: 5,
                fontColor: "#aaa",
                min: this.graphdetail_data.minmax.average_engagement_rate_min,
                max: this.graphdetail_data.minmax.average_engagement_rate_max,
              },
            },
            {
              id: "transparent",
              display: false,
              ticks: {
                max: 5,
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.graphColor();
    this.$nextTick(() => {
      this.renderChart(this.datas, this.options);
    });
  },
  methods: {
    graphColor() {
      var gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(0, "#0095f699");
      gradient.addColorStop(1, "#54ccdb11");
      this.datas.datasets[0].backgroundColor = gradient;
    },
  },
  watch: {
    graphdetail_data() {
      this.graphColor();
      this.renderChart(this.datas, this.options);
    },
  },
};
</script>
